<template>
    <div>
        <b-form-group
            label="Question"
            label-for="question"
        >
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question', $event)"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
            label="Suggested Answer"
            label-for="suggested_answer"
        >
            <TipTap
                v-model="editable_content.suggested_answer"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('suggested_answer', $event)"
            />
        </b-form-group>

        <b-form-group
            label="Answer Background Image"
            label-for="answer_background_image"
        >
            <div class="d-flex justify-content-between">
                <b-dropdown
                    size="sm"
                    variant="outline-primary"
                    dropup
                    right
                >
                    <template #button-content>
                        <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Background Image
                    </template>
                    <b-dropdown-item @click.prevent="addExistingRelatedMedia">
                        <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width /> Add SBP Image
                    </b-dropdown-item>
                </b-dropdown>

                <b-button
                    v-if="editable_content.image.src"
                    variant="danger"
                    @click="removeBackgroundImage"
                    class="btn-sm ml-5"
                >
                    <span class="text-white"> <font-awesome-icon :icon="['fad', 'trash']" /> Remove Background Image</span>
                </b-button>
            </div>
        </b-form-group>
        <SbpMedia
            :media="editable_content.image"
            :key="editable_content.image.src"
            @update="update"
            @removeImage="removeBackgroundImage"
        />
        <add-related-media-modal
            v-model="show_add_related_media_modal"
            :type="'image'"
            @link="linkRelatedMediaItem"
            @hide="show_add_related_media_modal = false"
        />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import SbpMedia from '@/components/media/SbpMedia'

export default {
    data: () => ({
        editable_content: {
            image: {},
            question: '',
        },
        show_add_related_media_modal: false,
    }),
    props: [
        'question'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap'),
        AddRelatedMediaModal,
        SbpMedia
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        setContent (field, value) {
            this.$set(this.editable_content, field, value)
        },
        linkRelatedMediaItem(item){
            this.editable_content.image = {};
            this.editable_content.image.related_media_id = item.id
            this.editable_content.image.type = 'image'
            this.editable_content.image.title = item.title
            this.editable_content.image.description = item.description
            this.editable_content.image.credit = item.credit
            this.editable_content.image.caption = item.caption
            this.editable_content.image.src = item.url
            this.editable_content.image.alt = item.alt
            if (this.editable_content.image.merlin_id) delete this.editable_content.image.merlin_id;

            this.show_add_related_media_modal = false;
        },
        removeBackgroundImage() {
            this.$swal({
                    html: 'Are you sure you want to remove the background image?',
                    showCancelButton: true,
                    confirmButtonText: 'Remove Image',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.editable_content.image = {};
                    }
                })
        },
        update (media) {
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                this.editable_content.image.merlin_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                this.editable_content.image.related_media_id = !isNaN(mediaId) ? mediaId : null
            }
            this.editable_content.image.type = media.type
            this.editable_content.image.src = media.src
            this.editable_content.image.alt = media.alt
            this.editable_content.image.credit = media.credit
            this.editable_content.image.description = media.description
            this.editable_content.image.caption = media.caption
            this.editable_content.image.name = media.name ? media.name : (media.title ? media.title : '')
        },
        addExistingRelatedMedia(){
            if (
                this.editable_content.image &&
                this.editable_content.image.src
            ) {
                this.$swal({
                    html: 'Are you sure you want select a different image?',
                    showCancelButton: true,
                    confirmButtonText: 'Select Different Image',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.show_add_related_media_modal = true
                    }
                })
            } else {
                this.show_add_related_media_modal = true;
            }
        },
    }
}
</script>
